import { withServiceImplementation } from '@myaccount/utils';

import INavigationMenu from './NavigationMenuInterface';

export default withServiceImplementation(INavigationMenu, {});